<template>

  <ProductionOrderEmbeddable @mounted="onMountedDefault" v-model="form">

    <template #item(typeNonConformance)="{item}">

      <span v-if="item.materialId === 17">{{item.typeNonConformance || '-'}}</span>
      <span v-else>{{item.typeRestriction || '-'}}</span>

    </template>

  </ProductionOrderEmbeddable>

</template>
<script>
import productionOrderEmbeddableMixin from "@/mixins/embeddable/production/productionOrderEmbeddableMixin"

export default {
  name: 'PolimixProductionOrder',
  mixins: [productionOrderEmbeddableMixin],
  data() {
    return {
      form: {
        /*Declarar somente campos fora do padrão que podem ser utilizados na busca*/

      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {


    async mountedContinued() {

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {


  },
}
</script>
